class MapTeaser {
    constructor(element) {
        this.trigger = element.querySelector('.js-map-teaser-trigger');
        this.iframe = element.querySelector('.js-map-teaser-iframe');
        this.iframeSrc = element.dataset.iframe;

        this.initEvent();
    }

    initEvent() {
        this.trigger.addEventListener('click', (event) => {
            event.preventDefault();
            this.showContent();
        });
    }

    showContent() {
        this.iframe.src = this.iframeSrc;
        this.iframe.style.display = 'block';
    }
}

const mapTeaser = {
    init() {
        const elements = document.querySelectorAll('.js-map-teaser');

        if (!elements) return;

        elements.forEach((element) => {
            this.mapTeaser = new MapTeaser(element);
        });
    },
};

export default mapTeaser;
